// @flow
import React, { Component } from 'react';
import './GrayBox.scss';

type GrayBoxProps = {
  min: number,
  max: number,
};

class GrayBox extends Component<GrayBoxProps> {
  static defaultProps = {
    min: 1,
    max: 6,
  };
  size: number = 1;

  constructor(props) {
    super(props);
    const { max, min } = this.props;
    this.size = min + Math.random() * (max - min);
  }

  render() {
    return <div className="gray-box keyframes blink" style={{ width: `${this.size}rem` }} />;
  }
}

export default GrayBox;



// WEBPACK FOOTER //
// ./src/components/common/GrayBox/GrayBox.js